import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <main className="min-h-screen bg-background-50 flex items-center justify-center pt-16">
      <div className="text-center px-4">
        <div className="w-24 h-24 flex items-center justify-center mx-auto mb-6 rounded-3xl bg-background-100">
          <i className="ri-emotion-sad-line text-4xl text-foreground-400"></i>
        </div>
        <h1 className="text-5xl md:text-7xl font-bold text-foreground-200 mb-3">404</h1>
        <h2 className="text-lg md:text-xl font-semibold text-foreground-600 mb-6">页面未找到</h2>
        <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
          您访问的页面不存在或已被移除，请检查链接是否正确。
        </p>
        <Link
          to="/"
          className="px-6 py-2.5 text-sm font-semibold rounded-lg bg-primary-500 text-background-950 hover:bg-primary-400 transition-all duration-300 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
        >
          <i className="ri-arrow-left-line"></i>
          返回首页
        </Link>
      </div>
    </main>
  );
}